import { useQuery } from '@tanstack/react-query';

import type { InFieldLocationConfig } from '@cognite/apm-client';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

export const useAllInFieldLocationConfigs = () => {
  const { apmClient } = useFDMServices();

  return useQuery<InFieldLocationConfig[], Error>({
    queryKey: [QueryKeys.INFIELD_LOCATION_CONFIG, 'all'],
    queryFn: async () => {
      const response = await apmClient.infieldLocationConfig.list(
        `
      externalId
      rootLocationExternalId
      featureToggles
    `
      );
      return response.list.items;
    },
  });
};
